
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { addDays, format } from 'date-fns'
import { useAuth } from '../../contexts/AuthContext'
import { usePost } from './../../apis/ApiRequests'
import { dateToString } from '../../utils/Library'
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material'
import { facilityData } from '../../Store'

const BidListMonitor = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode ? authInfo.facilityCode : facilityData.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId ? authInfo.userId : 'Signage'
    const luserName      = authInfo.userName
    const authority      = authInfo.authority
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd')
    const navigate       = useNavigate()

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ entryDate, setEntryDate] = useState(today)
    const [ bidList,   setBidList  ] = useState([])
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - searchDataByUnload / Signage
	//-----------------------------------------------
    const { response : searchData_res, post:searchData_post } = usePost()
    const searchData = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.Signage',
            'methodName'   : 'searchDataByBidList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
        }
        await searchData_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        searchData()
        
        // 30秒ごとにデータを更新するタイマーを設定
        const interval = setInterval(searchData, 5000)
    
        // コンポーネントのアンマウント時にタイマーをクリア
        return () => clearInterval(interval)
        
    },[])
	//-----------------------------------------------
    // useEffect - searchDataByUnload / Signage
	//-----------------------------------------------
    useEffect(() => {
        setBidList([])
        if (searchData_res) {
            setBidList(searchData_res.Data)
        }
    }, [searchData_res])

	//===============================================
	// eventHandler
	//===============================================
    const handleClick_header = () => {
        userId == 'Signage' ? navigate('/') : navigate('/signageMenu')
    }
    //===============================================
    // Css
    //===============================================
    const bidListMonitor_table_cell_header = {
        backgroundColor: '#fff', color: '#005243', borderRight:'3px solid #005243', borderBottom:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em'
    }
    function getBackgroundColor(bidStatus, index) {
        
        // 入札中
        if (bidStatus == 1) {
            return {
                padding:'5px', fontSize:'2em', fontWeight:'bold', 
                backgroundColor: '#ff0000', color: '#fff', borderBottom:'3px solid #fff', borderRight:'3px solid #fff'
            }
        // 落札済み
        } else if (bidStatus == 8) {
            return {
                padding:'5px', fontSize:'2em', fontWeight:'bold', 
                backgroundColor: '#ffa500', color: '#fff', borderBottom:'3px solid #fff', borderRight:'3px solid #fff'
            }
        // 落札済み
        } else if (bidStatus == 9) {
            return {
                padding:'5px', fontSize:'2em', fontWeight:'bold', 
                backgroundColor: '#005243', color: '#fff', borderBottom:'3px solid #fff', borderRight:'3px solid #fff'
            }
        } else {
            return {
                padding:'5px', fontSize:'2em', fontWeight:'bold', 
                backgroundColor: '#fff', color: '#005243', borderBottom:'3px solid #005243', borderRight:'3px solid #005243'
            }
        }
      }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <div className='bidGroup signageContens' style={{ height: '100vh',overflow:'hidden' }}>
                <div style={{textAlign:'center'}} onClick={() => handleClick_header()}>
                    <div>
                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#fff'}}>【入札情報】</span>
                    </div>
                    <div>
                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#fff'}}>{ today }</span>
                    </div>
                </div>
                <div>
                    <TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'1em'}}>
                        <Table stickyHeader sx={{ minWidth: '500px', padding:0 }} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={ bidListMonitor_table_cell_header } style={{ width: '30vh',borderLeft:'3px solid #fff' }} align="center">荷主</TableCell>
                                    <TableCell sx={ bidListMonitor_table_cell_header } style={{ width: '45vh' }} align="center">品名</TableCell>
                                    <TableCell sx={ bidListMonitor_table_cell_header } style={{ width: '11vh' }} align="center">単位</TableCell>
                                    <TableCell sx={ bidListMonitor_table_cell_header } style={{ width: '15vh' }} align="center">数量</TableCell>
                                    <TableCell sx={ bidListMonitor_table_cell_header } style={{ width: '15vh' }} align="center">容器</TableCell>
                                    <TableCell sx={ bidListMonitor_table_cell_header } style={{ width: '15vh' }} align="center">Kg数</TableCell>
                                    <TableCell sx={ bidListMonitor_table_cell_header } style={{ width: '35vh' }} align="center">備考</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {bidList.map((row, index) => (
                                <TableRow key = { row.id } >
                                    <TableCell sx={ getBackgroundColor(row.bidStatus, index) } align="left" style={{borderLeft:'3px solid #fff'}}>{ row.senmei }</TableCell>
                                    <TableCell sx={ getBackgroundColor(row.bidStatus, index) } align="left">{ row.displayGyoshu }</TableCell>
                                    <TableCell sx={ getBackgroundColor(row.bidStatus, index) } align="center">{ row.kgKubunName }</TableCell>
                                    <TableCell sx={ getBackgroundColor(row.bidStatus, index) } align="right">{ row.suryo }</TableCell>
                                    <TableCell sx={ getBackgroundColor(row.bidStatus, index) } align="center">{ row.yoki }</TableCell>
                                    <TableCell sx={ getBackgroundColor(row.bidStatus, index) } align="right">{ row.kgSuryo }</TableCell>
                                    <TableCell sx={ getBackgroundColor(row.bidStatus, index) } align="left">{ row.displayBiko }</TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    )
}
export default BidListMonitor
  